import React from 'react'

type DocumentSectionProps = {
  header: string
  content: string | React.ReactNode
}

export const DocumentSection = ({ header, content }: DocumentSectionProps) => (
  <div className="flex flex-col gap-2 items-start">
    <div className="md:text-2xl text-xl font-bold">{header}</div>
    <div>{content}</div>
  </div>
)

type DocumentPageProps = {
  title: string
  caption?: string
  content: string | React.ReactNode
}

const DocumentPage = ({ title, caption, content }: DocumentPageProps) => (
  <div className="flex flex-col w-full h-full items-center">
    <div className="flex flex-col gap-2 md:px-16 md:py-11 sm:p-12 p-8 bg-slate-900 w-full text-center">
      <div className="font-semibold md:text-4xl text-2xl uppercase  text-white">{title}</div>
      {caption && <div className="text-slate-400 md:text-lg text-md">{caption}</div>}
    </div>
    <div className="xl:px-0 xl:py-[88px] lg:px-24 lg:py-16 md:px-16 sm:p-12 p-8 max-w-[768px]">
      <div className="flex flex-col gap-4">{content}</div>
    </div>
  </div>
)

export default DocumentPage
